import Box from '@totallymoney/ui/components/Box'

import { CategoryPath } from '@config/categories'

import ContentCarFinance from './components/ContentCarFinance'
import ContentGuarantor from './components/ContentGuarantor'
import ContentPersonal from './components/ContentPersonal'
import ContentPoorCredit from './components/ContentPoorCredit'
import ContentSecured from './components/ContentSecured'
import ContentUnsecured from './components/ContentUnsecured'

const FrequentlyAskedQuestions = ({
    category,
}: {
    category: CategoryPath | 'unsecured'
}) => (
    <Box display="grid" gridGap="space20">
        {(() => {
            switch (category) {
                case 'all': {
                    return <ContentPersonal />
                }
                case 'bad-credit': {
                    return <ContentPoorCredit />
                }
                case 'homeowner': {
                    return <ContentSecured />
                }
                case 'unsecured':
                    return <ContentUnsecured />
                case 'car-finance':
                    return <ContentCarFinance />
                case 'guarantor':
                    return <ContentGuarantor />
                default: {
                    return <ContentPersonal />
                }
            }
        })()}
    </Box>
)

export default FrequentlyAskedQuestions
